import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetContractualTermLink,
	GetContractualTermLinkModel,
} from 'domain/usecases/private/home/get-contractual-term-link';

export class RemoteGetContractualTermLink implements GetContractualTermLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetContractualTermLinkModel>,
	) {}

	async get(): Promise<GetContractualTermLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
